import { DateTime } from "luxon";
import Datepicker from "react-tailwindcss-datepicker";
import { useTranslation } from "react-i18next";

// containerClassName sizes the box the calendar/clear toggle is positioned against. The library's
// own default is `relative w-full`, which stretches the container past the w-64 input and strands
// the toggle at the right edge of whatever the parent happens to be — the far side of a modal, in
// the worst case. Matching the container to the input's width keeps the toggle inside it. Callers
// that override inputClassName with a different width should pass a matching containerClassName;
// note the library ignores "" and falls back to its own default, so this must be a real class list.
export default function CustomDatePicker({
  dates,
  handleDatesChange,
  inputClassName = "text-sm border-gray-300 rounded-md w-64",
  containerClassName = "relative w-64 text-gray-700"
}) {
  const { t, i18n } = useTranslation("common");

  //**  This library is broken - can't use custom shortcuts in a .ts file!  **/

  return (
    <Datepicker
      inputClassName={inputClassName}
      toggleClassName="absolute text-black font-bold right-0 h-full px-3"
      containerClassName={containerClassName}
      placeholder={t("Filter by Date Range")}
      i18n={i18n.language}
      showShortcuts={true}
      useRange={false}
      value={dates}
      onChange={newValue => {
        if (newValue.startDate === null && newValue.endDate === null) { 
          handleDatesChange({startDate: null, endDate: null});
          return;
        };

        const newStartDate = new Date(newValue.startDate)
        const newEndDate = new Date(newValue.endDate)

        handleDatesChange({startDate: newStartDate, endDate: newEndDate})
      }}
      displayFormat="DD/MM/YYYY"
      configs={{
        shortcuts: {
          today: t("Today"),
          tomorrow: {
            text: t("Tomorrow"),
            daysNumber: 1,
            period: {
              start: DateTime.now().plus({ days: 1 }).toJSDate(),
              end: DateTime.now().plus({ days: 1 }).toJSDate()
            },
          },
          yesterday: t("Yesterday"),
          past: period => t("Past {{count}} days", { count: period }),
          nextThreeDays: {
            text: t("Next 3 Days"),
            daysNumber: 3,
            period: {
              start: DateTime.now().toJSDate(),
              end: DateTime.now().plus({ days: 3 }).toJSDate()
            },
          },
          nextSevenDays: {
            text: t("Next 7 Days"),
            daysNumber: 7,
            period: {
              start: DateTime.now().toJSDate(),
              end: DateTime.now().plus({ days: 7 }).toJSDate()
            },
          },
          currentMonth: t("This Month"),
          pastMonth: t("Last Month"),
          nextMonth: {
            text: t("Next Month"),
            period: {
              start: DateTime.now().plus({ months: 1 }).startOf("month").toJSDate(),
              end: DateTime.now().plus({ months: 1 }).endOf("month").toJSDate()
            },
          },
        }
      }}
    />
  )
}